export * from '@material-ui/core'
export * as materialStyles from '@material-ui/core/styles'
export * as materialIcons from '@material-ui/icons'
export * as materialLab from '@material-ui/lab'
export { default as defaultTheme } from './theme'
